import { IJob } from 'wisestep-api';
import create from 'zustand';

interface IConversationWidgetStore {
  selectedJob: IJob | null;
  updateSelectedJob(args: IJob | null): void;
  candidateIndex: number | null;
  updateCandidateIndex(args: number): void;
}

const conversationWidgetStore = create<IConversationWidgetStore>((set) => ({
  selectedJob: null,
  updateSelectedJob: (value: IJob | null) => set({ selectedJob: value }),
  candidateIndex: null,
  updateCandidateIndex: (value: number | null) => set({ candidateIndex: value }),
}));

export default conversationWidgetStore;
